/* ─────────────────────────────────────────────────────────────
   WithStar — renders a copy string, styling a literal "*" inside
   it (there is at most one per string) as a small muted footnote
   marker. Keeps data.js as plain, readable strings instead of
   pre-split JSX fragments, no matter where the asterisk falls in
   the sentence.
───────────────────────────────────────────────────────────── */
export default function WithStar({ text, className = "", starClassName = "text-[#0d0828]/35" }) {
  const idx = text.indexOf("*");

  if (idx === -1) {
    return <span className={className}>{text}</span>;
  }

  return (
    <span className={className}>
      {text.slice(0, idx)}
      <span className={`ml-px align-super text-[0.7em] font-semibold ${starClassName}`}>
        *
      </span>
      {text.slice(idx + 1)}
    </span>
  );
}
